import getColor from "@gcloud-npm/utils.enums.colors";

export const TRACKING_ORDER = {
    TITLE:"Seguimiento de la venta",
    PLACEHOLDER:"Introduce tu ID de seguimiento (Ej: CO87665645757)",
    BUTTON_TEXT:"Ver estado"
}

export const API_ERRORS = {
    //NOT_FOUND
    404: {
        title: 'No hemos encontrado ninguna solicitud asociada a ese ID de seguimiento',
        description: 'El ID de seguimiento introducido no existe, prueba a modificar la búsqueda.',
    },
    //EXPIRED
    400: {
        title: 'No hemos encontrado ninguna solicitud asociada a ese ID de seguimiento',
        description: 'La transacción asociada al ID introducido se completó hace más de 6 meses y ya no está accesible para su seguimiento online',
    },
    default:  {
        title: 'ERROR TITLE',
        description: 'ERROR DESC',
    }
}
    
const STEP_LABELS = {
    SOLICITUD : "Solicitud",
    RECOGIDA : "Recogida",
    EN_REVISION : "En revision",
    DIAGNOSTICO : "Diagnostico",
    PAGO : "Pago",
    DEVOLUCION : "Devolucion",
}
export const STEP_IDS = {
    STEP_1 : "1",
    STEP_2 : "2",
    STEP_3 : "3",
    STEP_4 : "4",
    STEP_5 : "5",
}
export const STEPPER = [
    {
        id: STEP_IDS.STEP_1,
        label: STEP_LABELS.SOLICITUD,
        isActive: false,
        isChecked: false,
        date:'',
    },
    {
        id: STEP_IDS.STEP_2,
        label: STEP_LABELS.RECOGIDA,
        isActive: false,
        isChecked: false,
        date:'',
    },
    {
        id: STEP_IDS.STEP_3,
        label: STEP_LABELS.EN_REVISION,
        isActive: false,
        isChecked: false,
        date:'',
    },
    {
        id: STEP_IDS.STEP_4,
        label: STEP_LABELS.DIAGNOSTICO,
        isActive: false,
        isChecked: false,
        date:'',
    },
    {
        id: STEP_IDS.STEP_5,
        label: STEP_LABELS.PAGO,
        isActive: false,
        isChecked: false,
        date:'',
    },
]
const NEXT_STEPS_ID = {
    NEXT_STEPS_01 : "solicitud",
    NEXT_STEPS_02 : "recogidaFallida",
    NEXT_STEPS_03 : "confirmacionDeRecogida",
    NEXT_STEPS_04 : "pago",
    NEXT_STEPS_05 : "confirmacionDeRecepcion",
    NEXT_STEPS_06 : "diagnosticoOK",
    NEXT_STEPS_07 : "diagnosticoKO",
    NEXT_STEPS_08 : "diagnosticoCambioPrecio",
    NEXT_STEPS_09 : "diagnosticoInformacioDevolucion",
}
export const NEXT_STEPS = {
    [NEXT_STEPS_ID.NEXT_STEPS_01]: [
        'Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte.',
        '&nbsp',
        'No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:',
        '- Desactiva cualquier bloqueo del dispositivo',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'
    ],
    [NEXT_STEPS_ID.NEXT_STEPS_02]: [
        'Zeleris, nuestra empresa de transportes, intentará recoger de nuevo tu dispositivo de forma gratuita. Recibirás un SMS para gestionar la recogida.', 
        '&nbsp',
        'No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:',
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'
    ],
    [NEXT_STEPS_ID.NEXT_STEPS_03]: [
        'Cuando nuestros expertos reciban el dispositivo lo revisarán para comprobar que el estado coincide con la descripción. Tendremos un diagnóstico en un plazo máximo de 4 días desde la recepción del dispositivo.',
        '- Si todo está bien, ingresaremos el dinero en tu cuenta.',
        '- Si no es así, te enviaremos una contraoferta adaptada al estado real del dispositivo.'
    ],
    [NEXT_STEPS_ID.NEXT_STEPS_04]: [
        'Ya hemos activado el pago, así que, pronto recibirás el dinero en tu cuenta. Ten en cuenta que puede tardar en llegar hasta 8 días desde la fecha en que realizamos el pago.',
    ],
    [NEXT_STEPS_ID.NEXT_STEPS_05]: [
        'Nuestros expertos están comprobando que el estado de tu dispositivo coincide con la descripción. Tendremos un diagnóstico en un plazo máximo de 4 días desde la recepción del dispositivo.',
        '- Si todo está bien, ingresaremos el dinero en tu cuenta.',
        '- Si no es así, te enviaremos por email una contraoferta adaptada al estado real del dispositivo.'
    ],
    [NEXT_STEPS_ID.NEXT_STEPS_06]: [
        'La descripción de tu dispositivo coincide con su estado y vamos a proceder a emitir la orden de pago de tu dispositivo.',
        'El ingreso se completará en un plazo máximo de 8 días desde que activemos el pago.'
    ],
    [NEXT_STEPS_ID.NEXT_STEPS_07]: [
        'Lo sentimos, tras revisar el dispositivo recibido, hemos concluido que no coincide con la descripción y no cumple las condiciones para la venta.',
        'En un plazo máximo de 3 días recibirás un email informándote sobre la devolución del dispositivo en la dirección que nos indicaste y un SMS de nuestra empresa de transportes Zeleris con la fecha.',
    ],
    [NEXT_STEPS_ID.NEXT_STEPS_08]: [
        'Lo sentimos, pero, después de revisar tu dispositivo, nuestro equipo lo ha tasado con un precio distinto al inicial. Te hemos enviado un mail desde el que podrás aceptar la nueva oferta o solicitar la devolución de tu dispositivo de forma gratuita. La oferta será válida durante 7 días desde la fecha de recepción del mail.',
        'Revisa la carpeta de correo no deseado si no lo has recibido.',
    ],
    [NEXT_STEPS_ID.NEXT_STEPS_09]: [
        'Zeleris, nuestra empresa de transporte, te devolverá tu dispositivo en los próximos días de forma gratuita. Recibirás un SMS de Zeleris con la fecha.',
    ],
}
export const STATES_IDS = {
    SOLICITUD: '00-0000',
    CREACION_RECOGIDA: '05-0010',
    INTENTO_RECOGIDA: '05-0100',
    RECOGIDO: '05-0500',
    EN_TRANSITO_A_LABORATORIO: '05-0600',
    INCIDENCIA_EN_TRANSPORTE_IN: '80-0150',
    RECIBIDO_EN_LABORATORIO: '15-0150',
    EQUIPO_EN_EVALUACION: '15-0200',
    INCIDENCIA_EN_PAGO: '80-0550',
    DISPOSITIVO_NO_COINCIDE: '80-9100',
    EXPEDICION_DEVOLUCION_CREADA: '20-0500',
    ORDEN_DE_DEVOLUCION_CREADA: '20-0550',
    EVALUACION_KO_MERCANCIA: '80-0200',
    KO_ENTREGA_DEVOLUCION: '20-0850',
    ORDEN_PAGO_GENERADA: '25-0100',
    INCIDENCIA_EN_TRANSPORTE_OUT: '80-0750',
    DEVOLUCION: '20-0800',
    NO_RECOGIDO_1: "90-0100",
    NO_RECOGIDO_2: "05-0300",
    ORDEN_DE_DESTRUCION: "80-0900",
}
export const STATES = {
    [STATES_IDS.SOLICITUD] : { //done //ns
        STEP_ID: '1',
        STEP_LABEL: STEP_LABELS.SOLICITUD,
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_01],
        SHOW_PICK_UP_DATA: true,
        REFUND_REASON : "",
    },
    [STATES_IDS.CREACION_RECOGIDA] : { //done //ns
        STEP_ID: '1',
        STEP_LABEL: STEP_LABELS.SOLICITUD,
        TEXT_INFO_TITLE: 'Pronto recogeremos tu dispositivo',
        TEXT_INFO_DESC: 'Nuestra empresa de transporte Zeleris recogerá tu dispositivo',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_01],
        SHOW_PICK_UP_DATA: true,
        REFUND_REASON : "",
    },
    [STATES_IDS.INTENTO_RECOGIDA] : { //done /ns
        STEP_ID: '1',
        STEP_LABEL: STEP_LABELS.SOLICITUD,
        TEXT_INFO_TITLE: 'No hemos podido recoger tu dispositivo en la dirección indicada',
        TEXT_INFO_DESC: 'Contactaremos contigo para fijar una nueva cita',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_02],
        SHOW_PICK_UP_DATA: true,
        REFUND_REASON : "",
    },
    //RECOGIDA
    [STATES_IDS.RECOGIDO] : { //done //ns
        STEP_ID: '2',
        STEP_LABEL: STEP_LABELS.RECOGIDA,
        TEXT_INFO_TITLE: 'Hemos recogido tu dispositivo',
        TEXT_INFO_DESC: 'Lo llevaremos a nuestro laboratorio para comprobar el estado',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_03],
        SHOW_PICK_UP_DATA: true,
        REFUND_REASON : "",
    },
    [STATES_IDS.EN_TRANSITO_A_LABORATORIO] : { //done //ns
        STEP_ID: '2',
        STEP_LABEL: STEP_LABELS.RECOGIDA,
        TEXT_INFO_TITLE: 'Tu dispositivo está de camino a nuestro laboratorio',
        TEXT_INFO_DESC: 'Nuestros expertos lo revisarán para comprobar el estado',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_03],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "",
    },
    [STATES_IDS.INCIDENCIA_EN_TRANSPORTE_IN] : { //done //ns
        STEP_ID: '2',
        STEP_LABEL: STEP_LABELS.RECOGIDA,
        TEXT_INFO_TITLE: 'Se ha producio una incidencia en el transporte e tu dispositivo',
        TEXT_INFO_DESC: 'Nos pondremos en contacto contigo para ofrecerte una solución',
        NEXT_STEP: [],
        SHOW_PICK_UP_DATA: true,
        REFUND_REASON : "",
    },
    //EN_REVISION
    [STATES_IDS.RECIBIDO_EN_LABORATORIO] : { //done //ns
        STEP_ID: '3',
        STEP_LABEL: STEP_LABELS.EN_REVISION,
        TEXT_INFO_TITLE: 'Nuestros expertos están revisando tu dispositivo',
        TEXT_INFO_DESC: 'Si todo está bien procederemos a ingresarte el dinero en tu cuenta',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_05],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "",
    },
    //DIAGNOSTICO,
    [STATES_IDS.EQUIPO_EN_EVALUACION] : { //done //ns
        STEP_ID: '4',
        STEP_LABEL: STEP_LABELS.DIAGNOSTICO,
        TEXT_INFO_TITLE: 'Hemos validado el estado de tu dispositivo',
        TEXT_INFO_DESC: 'Vamos a proceder a emitir la orden de pago de tu dispositivo',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_06],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "",
    },
    [STATES_IDS.INCIDENCIA_EN_PAGO] : { //done
        STEP_ID: '4',
        STEP_LABEL: STEP_LABELS.DIAGNOSTICO,
        TEXT_INFO_TITLE: 'La orden de pago del dispositivo no ha podido efectuarse',
        TEXT_INFO_DESC: 'Contactaremos contigo para ofrecerte una solución',
        NEXT_STEP: [],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "",
    },
    [STATES_IDS.DISPOSITIVO_NO_COINCIDE] : { //done //ns
        STEP_ID: '4',
        STEP_LABEL: STEP_LABELS.DIAGNOSTICO,
        TEXT_INFO_TITLE: 'Hemos ajustado la oferta acorde al dispositivo recibido',
        TEXT_INFO_DESC: 'Revisa tu email para confirmar la nueva oferta o solicitar la devolución',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_08],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "",
    },
    [STATES_IDS.EXPEDICION_DEVOLUCION_CREADA] : { //done //ns
        STEP_ID: '4',
        STEP_LABEL: STEP_LABELS.DIAGNOSTICO,
        TEXT_INFO_TITLE: 'Pronto te devolveremos tu dispositivo',
        TEXT_INFO_DESC: 'Nuestra empresa de transporte Zeleris te devolverá tu dispositivo',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_09],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "Oferta rechazada",
    },
    [STATES_IDS.ORDEN_DE_DEVOLUCION_CREADA] : { //done //ns
        STEP_ID: '4',
        STEP_LABEL: STEP_LABELS.DIAGNOSTICO,
        TEXT_INFO_TITLE: 'Pronto te devolveremos tu dispositivo',
        TEXT_INFO_DESC: 'Nuestra empresa de transporte Zeleris te devolverá tu dispositivo',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_09],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "Oferta rechazada",
    },
    [STATES_IDS.EVALUACION_KO_MERCANCIA] : { //done //ns
        STEP_ID: '4',
        STEP_LABEL: STEP_LABELS.DIAGNOSTICO,
        TEXT_INFO_TITLE: 'Tu dispositivo no cumple las condiciones para la venta',
        TEXT_INFO_DESC: 'Te lo devolveremos lo antes posible',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_07],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "No cumple condiciones",
    },
    [STATES_IDS.KO_ENTREGA_DEVOLUCION] : { //done //ns
        STEP_ID: '4',
        STEP_LABEL: STEP_LABELS.DIAGNOSTICO,
        TEXT_INFO_TITLE: 'La devolución de tu dispositivo no ha podido completarse',
        TEXT_INFO_DESC: 'Nos pondremos en contacto contigo para gestionar la entrega',
        NEXT_STEP: [],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "Oferta rechazada",

    },
    [STATES_IDS.INCIDENCIA_EN_TRANSPORTE_OUT] : { //done
        STEP_ID: '4',
        STEP_LABEL: STEP_LABELS.DIAGNOSTICO,
        TEXT_INFO_TITLE: 'Se ha producido una incidencia en el transporte de tu dispositivo',
        TEXT_INFO_DESC: 'Nos pondremos en contacto contigo para ofrecerte una solución',
        NEXT_STEP: [],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "Oferta rechazada",
    },
    //PAGO,
    [STATES_IDS.ORDEN_PAGO_GENERADA] : { //done //ns
        STEP_ID: '5',
        STEP_LABEL: STEP_LABELS.PAGO,
        TEXT_INFO_TITLE: 'Hemos emitido la orden de pago de tu dispositivo',
        TEXT_INFO_DESC: 'El ingreso se completará en un plazo de 8 días',
        NEXT_STEP: NEXT_STEPS[NEXT_STEPS_ID.NEXT_STEPS_04],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "",
    },
    //DEVOLUCION
    [STATES_IDS.DEVOLUCION] : { //done //ns
        STEP_ID: '5',
        STEP_LABEL: STEP_LABELS.DEVOLUCION,
        TEXT_INFO_TITLE: 'Te hemos devuelto tu dispositivo',
        TEXT_INFO_DESC: '',
        NEXT_STEP: [],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "Oferta rechazada",
    },
    //SIN STEPPER
    [STATES_IDS.NO_RECOGIDO_1] : { //done //ns
        STEP_ID: '0',
        TEXT_INFO_TITLE: 'El proceso de venta de tu dispositivo se ha cancelado',
        TEXT_INFO_DESC: 'Hemos intentado recoger tu dispositivo hasta en 3 ocasiones sin éxito',
        NEXT_STEP: [],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "",
    },
    [STATES_IDS.NO_RECOGIDO_2] : {//done //ns
        STEP_ID: '0',
        TEXT_INFO_TITLE: 'El proceso de venta de tu dispositivo se ha cancelado',
        TEXT_INFO_DESC: 'Hemos intentado recoger tu dispositivo hasta en 3 ocasiones sin éxito',
        NEXT_STEP: [],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "",
    },
    [STATES_IDS.ORDEN_DE_DESTRUCION] : {//done //ns
        STEP_ID: '0',
        TEXT_INFO_TITLE: 'Hemos enviado tu dispositivo a un punto limpio para reciclar',
        TEXT_INFO_DESC: 'Gracias por contribuir para que nuestro planeta sea mas sostenible',
        NEXT_STEP: [],
        SHOW_PICK_UP_DATA: false,
        REFUND_REASON : "",
    },
}

export const DIAGNOSIS_TEXTS = {
    'E': 'Enciende y funcionan los botones, falla algún componente',
    'D':'Enciende y funcionan los botones y componentes, falla la cámara, pantalla o batería',
    'A+': 'Funciona correctamente, estado nuevo',
    'A': 'Funciona correctamente, buen estado.',
    'B': 'Funciona correctamente, aspecto usado.',
    'C': 'Funciona correctamente, aspecto dañado.',
};
export const REFUND_TEXTS = (refundReason)=> ({
    title : "Datos de recogida",
    texts: {
        "Transporte" : "Solicitud",
        "Empresa" : "Recogida",
        "Motivo devolución": refundReason
    },
})
export const PICK_UP_TEXTS = {
    title : "Datos de devolución",
    texts: {
        "Transporte" : "Solicitud",
        "Empresa" : "Recogida",
    },
}
export const SALE_DETAILS_TEXTS = ({id, modelName, deviceDiagnosis, devicePrice })=> ({
    title : "Detalle de la venta",
    texts: {
        "ID de seguimiento" : id,
        "Modelo" : modelName,
        "Estado del dispositivo" : deviceDiagnosis,
        "Valoración del dispositivo" : `${devicePrice}`,
    },
})
const bluea = getColor("BLUE_A");
export const HELP_TEXTS =[ 
    "<b>¿Tienes alguna duda?<b/>",
    `Escríbenos a <spam style='color:${bluea}'>soporte@recompra.movistar.es</spam>`,
    "Horario de atención: lunes a viernes 9 a 18 h.",
]
